
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40.86 37.09"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"crowd-icon-prefix__cls-1",attrs:{"cx":"32.14","cy":"8.08","r":"7.08","stroke-linecap":"round","stroke-linejoin":"round","stroke":"#fff","stroke-width":"2","fill":"#5d606f"}}),_c('circle',{staticClass:"crowd-icon-prefix__cls-1",attrs:{"cx":"8.47","cy":"8.28","r":"6.87","stroke-linecap":"round","stroke-linejoin":"round","stroke":"#fff","stroke-width":"2","fill":"#5d606f"}}),_c('circle',{staticClass:"crowd-icon-prefix__cls-1",attrs:{"cx":"20.42","cy":"12.68","r":"9","stroke-linecap":"round","stroke-linejoin":"round","stroke":"#fff","stroke-width":"2","fill":"#5d606f"}}),_c('path',{staticClass:"crowd-icon-prefix__cls-2",attrs:{"d":"M.69 25.69a.69.69 0 01-.69-.82c.45-2.12 2.2-7.6 8.55-7.44s8 5.4 8.38 7.45a.69.69 0 01-.68.81zm23.91-.02a.69.69 0 01-.68-.83c.45-2.12 2.2-7.59 8.55-7.43s8 5.39 8.37 7.44a.68.68 0 01-.67.82z","fill":"#5d606f"}}),_c('path',{staticClass:"crowd-icon-prefix__cls-3",attrs:{"d":"M9 36.09a2 2 0 01-1.89-2.42c1-4 4.2-11.5 13.5-11.26s12.29 7.42 13.25 11.28a1.94 1.94 0 01-1.86 2.4z","stroke-miterlimit":"10","stroke":"#fff","stroke-width":"2","fill":"#5d606f"}})])
          )
        }
      }
    